'use client';

import Login from '@/app/login/components/Login';
import { Alert } from 'flowbite-react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function LoginPage() {
	const [sessionExpired, setSessionExpired] = useState(false);

	useEffect(() => {
		const handleSessionExpired = () => {
			setSessionExpired(true);
		};

		window.addEventListener('sessionExpired', handleSessionExpired);

		return () => {
			window.removeEventListener('sessionExpired', handleSessionExpired);
		};
	}, []);

	return (
		<div>
			{sessionExpired && (
				<Alert color="failure">
					Sesi Anda telah berakhir. Silakan login kembali.
				</Alert>
			)}
			<Login />
		</div>
	);
}
